import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef, ViewEncapsulation } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DfCatalogUiModule } from '@df/catalog-ui/df-catalog-ui.module';
import { IPageDataV3 } from '@df/catalog/cms/cms-model.interface';
import { GtmTrackViewItemListDirective } from '@df/module-gtm/track/view-item-list/gtm-track-view-item-list.directive';
import { DfImageWrapperComponent } from '@df/module-image/df-image-wrapper.component';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { InfiniteScrollDirective } from '@df/module-infinite-scroll/infinite-scroll.directive';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent } from '@icms/core/content';
import { ICmsPage } from '@icms/core/resource/page/icms-page';
import { CmsBlogPostComponent } from '../../../../../cms/blog/post/cms-blog-post.component';
import { NCmsBlogPost } from '../../../../../cms/blog/post/cms-blog-post.interface';
import { CustomCursorComponent } from '../../../../../ui/display/custom-cursor/custom-cursor.component';
import { CategoryComponent } from '../../../category/category.component';
import { ProductComponent } from '../../../product/product.component';
import { LocalModelCarouselV2Component } from '../local-model-carousel-v2/local-model-carousel-v2.component';
import { getFields } from '../local-model-carousel-v2/local-model-carousel-v2.config';

@Component({
    selector: 'page-component-blog-post-carousel-v2',
    templateUrl: './../local-model-carousel-v2/local-model-carousel-v2.html',
    styleUrl: './../local-model-carousel/local-model-carousel.scss',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        CategoryComponent,
        CmsBlogPostComponent,
        CommonModule,
        CustomCursorComponent,
        DfCatalogUiModule,
        DfImageDirective,
        DfImageWrapperComponent,
        GtmTrackViewItemListDirective,
        GridModule,
        HrefComponent,
        ICmsClientModule,
        InfiniteScrollDirective,
        forwardRef(() => ProductComponent),
        RouterModule,
        SizeClassDirective,
        TranslatePipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<PageComponentBlogPostCarouselV2Component>({
    id: 'blog-post-carousel-v2',
    name: 'Blog Post Carousel (Variant 2)',
    description: 'Editorial carousel (without loop)',
    tags: ['images', 'carousel', 'slider', 'blog post'],
    fields: getFields(ICmsPage.type, NCmsBlogPost.typeId)
})
export class PageComponentBlogPostCarouselV2Component extends LocalModelCarouselV2Component<ICmsPage<IPageDataV3<NCmsBlogPost.ITypeData>>> {
    type = ICmsPage.type;
}
